export const LOADER_STATUS = 'boilerplate/IMS_PREPARE/LOADER_STATUS';
export const SET_IMS_FETCH_HISTORY = 'boilerplate/IMS_PREPARE/SET_IMS_FETCH_HISTORY';
export const SET_IMS_FETCH_HISTORY_PAGE_NO = 'boilerplate/IMS_PREPARE/SET_IMS_FETCH_HISTORY_PAGE_NO';
export const IMS_UPLOAD_HISTORY_DATA = 'boilerplate/IMS_PREPARE/IMS_UPLOAD_HISTORY_DATA';
export const IMS_SUMMARY_DATA = 'boilerplate/IMS_PREPARE/IMS_SUMMARY_DATA';
export const SAVE_TOTAL_PAGES_UPLOAD_HISTORY = 'boilerplate/IMS_PREPARE/SAVE_TOTAL_PAGES_UPLOAD_HISTORY';


